import { UserbotBatches } from "../interfaces"

/** RU-метки kinds словарей профилей (спека §7). */
export const PROFILE_DICT_KIND_LABELS: Record<
  UserbotBatches.ProfileDictKind,
  string
> = {
  first_name_male: "Мужские имена",
  first_name_female: "Женские имена",
  last_name: "Фамилии",
  username: "Юзернеймы",
  username_prefix: "Префиксы юзернеймов",
  username_suffix: "Суффиксы юзернеймов",
  avatar_male: "Аватары (муж.)",
  avatar_female: "Аватары (жен.)",
  avatar_abstract: "Аватары (абстракт)",
}
